import Page from '../components/common/Page';

const Dashboard = () => {
  return (
    <Page>
      dashboard
    </Page>
  );
};

export default Dashboard;
